<template>
  <div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form :form="form" layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="客户名称">
                <a-input
                  placeholder="请输入客户名称"
                  v-decorator="['customerName']"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="手机号">
                <a-input
                  placeholder="请输入手机号"
                  v-decorator="['mobile']"
                ></a-input>
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="问卷名称">
                  <a-input
                    placeholder="请输入问卷名称"
                    v-decorator="['questionnaireName']"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="客户类型">
                  <a-select
                    placeholder="请选择问卷名称"
                    v-decorator="['custType']"
                  >
                    <a-select-option value="1">
                      个人
                    </a-select-option>
                    <a-select-option value="0">
                      机构
                    </a-select-option>
                    <a-select-option value="2">
                      产品
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="风险等级">
                  <a-select
                    placeholder="请选择风险类型"
                    v-decorator="['riskLevel']"
                  >
                    <a-select-option
                      :value="item.value"
                      v-for="item in riskList"
                      :key="item.id"
                    >
                      {{ item.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? '收起' : '展开' }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table">
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          bordered
          :columns="columns"
          :data-source="answerArr"
          rowKey="id"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          @change="handleTableChange"
        >
          <span slot="fundIcon" slot-scope="text">
            <a-tag color="red" v-show="text == 'hot'"> hot </a-tag>
            <a-tag color="blue" v-show="text == 'new'"> new </a-tag>
            <a-tag
              style="
                background: rgba(240, 245, 254);
                border-color: #1890ff;
                color: #1890ff;
              "
              v-show="text == 'good'"
            >
              good
            </a-tag>
          </span>

          <template slot="operation" slot-scope="text, record">
            <a href="javascript:;" @click="handleDetail(record)">查看详情</a>
          </template>
        </a-table>
      </div>
      <answer-details ref="answer" @callback="initProductList"></answer-details>
    </a-card>
  </div>
</template>
<script>
import { answerList } from '@/api/product';
import { ajaxGetDictItems } from '@/api/api';
import answerDetails from './modules/answerDetails.vue';

const columns = [
  {
    title: '客户名称',
    align: 'center',
    dataIndex: 'customerName'
  },
  {
    title: '客户类型',
    align: 'center',
    dataIndex: 'custType',
    customRender: function(text) {
      if (text == 1) {
        return '个人';
      } else if (text == 0) {
        return '机构';
      } else if (text == 2) {
        return '产品';
      } else {
        return;
      }
    }
  },

  // { title: '产品规模', align: 'center', dataIndex: 'productScale', width: 100 },
  {
    title: '问卷类型',
    align: 'center',
    dataIndex: 'questionnaireName'
  },
  {
    title: '总计得分',
    align: 'center',
    dataIndex: 'totalScore' //0机构1个人
  },
  {
    title: '风险等级',
    align: 'center',
    dataIndex: 'riskLevel_dictText' //后台没返回 待修改
  },
  {
    title: '有效时间',
    align: 'center',
    dataIndex: 'effectiveTime',

    customRender: text => {
      return text == null ? '永久有效' : text;
    }
  },
  {
    title: '填写时间',
    align: 'center',
    dataIndex: 'createTime' //后台没返回 待修改
  },
  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 200,
    fixed: 'right',
    scopedSlots: {
      customRender: 'operation'
    }
  }
];
export default {
  components: { answerDetails },
  data() {
    return {
      riskList: [],
      form: this.$form.createForm(this),
      toggleSearchStatus: false,
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      answerArr: [],
      selectedRowKeys: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      columns,
      queryData: {}
    };
  },

  created() {
    this.initProductList(1);
    this.getRiskList();
  },
  methods: {
    handleDetail(record) {
      this.$refs.answer.handleVisible();
      this.$refs.answer.initGroupList(record);
    },
    //风险类型数据字典
    //获取banner分类
    getRiskList() {
      let code = 'user_risk';
      ajaxGetDictItems(code, null).then(res => {
        if (res.success) {
          this.riskList = res.result;
        }
      });
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    //重置
    searchReset() {
      this.form.resetFields();
      this.initProductList(1);
    },
    searchQuery() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // this.queryData = values;
          this.initProductList('1', values);
        }
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      this.ipagination = pagination;
      console.warn(pagination);

      this.initProductList();
    },

    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;

      console.log(this.selectionRows, '>>>>');
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },

    //table数据
    initProductList(arg, values) {
      let that = this;
      if (arg == 1) {
        this.ipagination.pageNo = 1;
      }
      let queryData = values ? values : {};
      that.loading = true;
      let params = {
        ...queryData,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      };
      answerList(params)
        .then(res => {
          that.loading = false;
          if (res.success) {
            that.answerArr =
              res.result && res.result.records ? res.result.records : [];
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    }
  }
};
</script>
<style scoped>
.table-operator {
  margin-bottom: 10px;
}
.table-operator .ant-btn {
  margin-right: 10px;
}
</style>
